window.addEventListener('DOMContentLoaded', async () => {
    const component = document.querySelector(".LiftVariantsComponent");
    if (!component) {
        return;
    }

    const module = await import('./lift-variations')
    module.default();
});
